// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    essaySchema,
    defaultEssayConfig,
    defaultEssayData,
    defaultEssayI18n,
    getSplitGridCols,
    GRADING_QUESTION_TYPES,
    type EssayContent,
    type EssayData,
    type EssayConfig,
    type EssayLayoutConfig,
    type EssayScoringConfig,
    type EssayQuestion,
    type EssayGradingType,
    type SplitRatio,
} from './schema';

// Components
export { EssayEdit, type EssayEditProps } from './EssayEdit';
export { EssayPlayer, type EssayPlayerProps } from './EssayPlayer';

export { essayContentGrader, gradeEssay, validateEssayAnswer, type EssayAnswer } from './scorer';

export { essayValidator } from './validator';

// Default export
export { essaySchema as default } from './schema';

export { countEssayQuestions, essayQuestionCounter } from './questionCount';
